type IseeRedirectMapping = {
  from: string;
  to: string;
  description?: string;
};

export const iseeRedirectMapping: IseeRedirectMapping[] = [
  {
    from: "10",
    to: "147",
    description: "ISEE 2023 to ISEE 2024",
  },
  {
    from: "147",
    to: "447",
    description: "ISEE 2024 to ISEE 2025",
  },
  {
    from: "439",
    to: "448",
    description: "Universitary ISEE 2024 to Universitary ISEE 2025",
  },
  {
    from: "447",
    to: "483",
    description: "ISEE 2025 to ISEE 2026",
  },
  { from: "448", to: "484", description: "Universitary ISEE 2025 to Universitary ISEE 2026" },
];
